module.exports = __webpack_public_path__ + "img/dior1.49029e21.jpg";